// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Şunun gibi tamamlanmış bir tarih kullanarak yeniden deneyin: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Grup',
  chart_labelSeries: () => 'Seri',
  chart_labelValue: () => 'Değer',
  checkboxSet_requiredMessageDetail: () => 'Gerekli',
  checkbox_requiredMessageDetail: () => 'Gerekli',
  close: () => 'Kapat',
  collection_noData: () => 'Görüntülenecek veri yok.',
  collection_selectAllRows: () => 'Tüm satırları seç',
  collection_selectRow: (p: { ROW_NAME: string }) => p['ROW_NAME'] + ' satırını seç',
  collection_sortDisabled: () => 'Sıralanabilir değil',
  collection_sortEnabled: () => 'Sıralanabilir',
  confirmation: () => 'Teyit',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + '/' + p['totalCount'],
  dataVisualization_noData: () => 'Görüntülenecek veri yok',
  dataVisualization_stateSelected: () => 'Seçildi',
  dataVisualization_stateUnselected: () => 'Seçim Kaldırıldı',
  error: () => 'Hata',
  expandableList_expandCollapseInstructionText: () =>
    'Genişletmek ve daraltmak için ok tuşlarını kullanın',
  expandableList_groupCollapse: () => 'Daraltıldı',
  expandableList_groupExpand: () => 'Genişletildi',
  filePicker_addFiles: () => 'Dosya Ekle',
  filePicker_dropzonePrimaryText: () => 'Sürükle ve Bırak',
  filePicker_dropzoneSecondaryText: () => 'Bir dosya seçin veya buraya bir dosya bırakın',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Dosya seçin veya buraya bırakın',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Karşıya yükleyemeyeceğiniz dosya tipleri: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Bir seferde karşıya bir tek dosya yükleyin',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Karşıya yükleyemeyeceğiniz dosya tipi: ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'bilinmeyen',
  formControl_clear: () => 'Temizle',
  formControl_day: () => 'Gün',
  formControl_helpAvailable: () => 'Yardım mevcut',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    ((({ one: '1 karakter' }) as Partial<Record<Intl.LDMLPluralRule, string>>)[
      new Intl.PluralRules('tr').select(p['CHARACTER_LIMIT'])
    ] || new Intl.NumberFormat('tr').format(p['CHARACTER_LIMIT']) + ' karakter') +
    ' sınırına ulaştınız.',
  formControl_loading: () => 'Yükleniyor ',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    p['MAX_LENGTH'] + ' olan maksimum uzunluk aşıldı.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' karakter kaldı.',
  formControl_month: () => 'Ay',
  formControl_readOnly: () => 'Salt okunur',
  formControl_requiredMessageDetail: () => 'Bir değer girin.',
  formControl_year: () => 'Yıl',
  gantt_labelDate: () => 'Tarih',
  gantt_labelEnd: () => 'Bitiş',
  gantt_labelLabel: () => 'Etiket',
  gantt_labelRow: () => 'Satır',
  gantt_labelStart: () => 'Başlangıç',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. Eşleşen bölüm bulunamadı.',
  indexer_keyboardInstructionText: () => 'Değer seçmek için Enter tuşuna basın.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    p['FROM_SECTION'] + ' ve ' + p['TO_SECTION'] + ' arasında.',
  indexer_touchInstructionText: () =>
    'İşaret moduna girmek için çıft tıklayıp basılı tutun, ardından aşağı veya yukarı sürükleyerek değeri ayarlayın.',
  info: () => 'Bilgi',
  inputDateMask_date_cleared: () => 'Tarih temizlendi',
  inputDateMask_dayPlaceholder: () => 'gg',
  inputDateMask_empty_segment: () => 'Boş',
  inputDateMask_monthPlaceholder: () => 'aa',
  inputDateMask_yearPlaceholder: () => 'yyyy',
  inputNumber_converterParseError: () => 'Sayı girin.',
  inputNumber_decrease: () => 'Azalt',
  inputNumber_increase: () => 'Arttır',
  inputPassword_hidden: () => 'Parola Gizli',
  inputPassword_hide: () => 'Parolayı Gizle',
  inputPassword_show: () => 'Parolayı Göster',
  list_suggestion: () => 'Öneri',
  messageToast_allMessagesClosed: () => 'Tüm durum mesajları kapatıldı.',
  message_close: () => 'Kapat',
  message_confirmation: () => 'Başarılı',
  message_error: () => 'Hata',
  message_info: () => 'Bilgi',
  message_navigationFromMessagesRegion: () =>
    'Mesajlar bölgesine giriliyor. Önceki odaklanılan öğeye gitmek için F6 tuşuna basın.',
  message_navigationToMessagesRegion: () =>
    'Mesajlar bölgesinde yeni mesajlar var. En yeni mesaj bölgesine F6 tuşuna basın.',
  message_warning: () => 'Uyarı',
  noData_message: () => 'Görüntülenecek öğe yok',
  overflowItemLabel: () => 'Diğer Sekmeler',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Devam Ediyor',
  radio_helpForRadio: () => 'Radyo düğmesi yardımı',
  radio_requiredMessageDetail: () => 'Bir değer seçin.',
  selectMultiple_apply: () => 'Uygula',
  selectMultiple_back: () => 'Geri',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Seçili değeri kaldırmak için Geri veya Sil tuşuna basın.',
  selectMultiple_selectedValues: () => 'Seçili değerler',
  selectMultiple_showSelectedValues: () => 'Sadece seçili değerleri göster.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' değer seçili.',
  select_addToList: () => 'Listeye ekle',
  select_addToListAvailable: () => 'Kullanılabilir listeye ekle',
  select_moreSearchOptions: () => 'Diğer arama seçenekleri',
  select_moreSearchOptionsAvailable: () => 'Diğer kullanılabilir arama seçenekleri',
  select_noMatchesFound: () => 'Eşleşme bulunmadı.',
  select_oneMatchFound: () => 'Bir eşleşme bulundu',
  select_requiredMessageDetail: () => 'Bir değer seçin.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' eşleşme bulundu',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' veya daha fazla eşleşme bulundu',
  selector_selected: () => 'Onay kutusu işaretli',
  selector_unselected: () => 'Onay kutusu işaretli değil',
  tabBarNavigationList_removeCueText: () => 'Kaldırılabilir',
  timeComponent_tooltipZoomIn: () => 'Yakınlaştır',
  timeComponent_tooltipZoomOut: () => 'Uzaklaştır',
  train_current: () => 'Geçerli',
  train_message_type: () => 'Mesaj Tipi',
  train_not_visited: () => 'Ziyaret edilmedi',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Adım ' + p['currentStep'] + ' / ' + p['numberOfSteps'],
  train_visited: () => 'Ziyaret edildi',
  userAssistance_learnMore: () => 'Daha fazla bilgi edinin',
  userAssistance_required: () => 'Gerekli',
  viz_drillable: () => 'Detaylandırılabilir',
  warn: () => 'Uyarı'
};
export default bundle;
